import React from "react";
import GeneralNotification from "../../components/notifications/GeneralNotification";
import SeasonInviteNotification from "../../components/notifications/SeasonInviteNotification";
import { useNotificationsStore } from "../../store/notificationsStore";
import { NotificationType } from "../../models/notificationModel";
import { formatDate } from "../../utils/dateUtils";
import VerifyEmail from "../../components/verifyEmail/VerifyEmail";
import useInvitationStore from "../../store/invitationsStore";
import { InvitationRenderer } from "../../components/notifications/InvitationRenderer";
import { useSeasonsStore } from "../../store/seasonsStore";

const NotificationRenderer: React.FC<any> = ({ notification, setIsRead }) => {
  if (notification.type === NotificationType.GeneralNotification) {
    return (
      <GeneralNotification
        isRead={notification.isRead}
        setIsRead={() => setIsRead(notification.id)}
        title={notification.title}
        description={notification.description}
        time={notification.time}
      />
    );
  }
  if (notification.type === NotificationType.SeasonNotification) {
    return (
      <SeasonInviteNotification
        notification={notification}
        seasonName={notification.seasonName}
        registrationCutoffDate={formatDate(notification.registrationCutOffDate)}
        seasonNumber={notification.seasonNumber}
      />
    );
  }
  return null;
};

const Notifications: React.FC = () => {
  const { notifications, setMarkAsRead } = useNotificationsStore();
  const { myInvitations, acceptUserInvitation, rejectUserInvitation } =
    useInvitationStore();
  const { currentSeason } = useSeasonsStore();
  const setIsRead = (id: string) => {
    setMarkAsRead(id);
  };

  const acceptInvitation = (id: string) => {
    if (currentSeason) {
      acceptUserInvitation(currentSeason.id, id);
    }
  };

  const declineInvitation = (id: string) => {
    if (currentSeason) {
      rejectUserInvitation(currentSeason.id, id);
    }
  };

  return (
    <div className="bg-gray-100 dark:bg-opacity-0 bg-opacity-35">
      <h1 className="text-xl font-semibold text-gray-700 dark:text-gray-100">
        Notifications
      </h1>

      <VerifyEmail />

      <InvitationRenderer
        invitations={myInvitations}
        onAccept={acceptInvitation}
        onDecline={declineInvitation}
      />

      {/* {notifications.length === 0 && myInvitations.length === 0 && ( */}
      <div className="space-y-4 max-w-lg mx-auto">
        <p key="0" className="text-center text-gray-500 dark:text-gray-300">
          No other notifications available
        </p>
      </div>
      {/* )} */}

      <div className="hidden">
        {notifications && notifications.length > 0 &&
          notifications
            .filter((n) => !n.isRead)
            .map((notification) => (
              <div key={notification.id}>
                <NotificationRenderer
                  notification={notification}
                  setIsRead={setIsRead}
                />
              </div>
            ))}
      </div>
    </div>
  );
};

export default Notifications;
